<template>
<div style="">
    <Jtron />
    <Solutions id="1"/>
    <AirPms />
    <About id="2"/>
</div> 
</template>

<script>

import Jtron from "./Jtron.vue"
import Solutions from "./Solutions.vue"
import AirPms from "./AirPms.vue"
import About from "./About.vue"
// import CategoryScroll from "./CategoryScroll.vue"

export default {
  name: 'Landing',
  data(){
      return{
        id: null,
        }
  },
  async mounted(){
    this.id = this.$route.params.id;
    console.log(this.id);

    if (this.id) {
        setTimeout(() => {
        document.getElementById(this.id).scrollIntoView({
        behavior: "smooth"
      });
 })
    }

    },

  methods : {
     
  },

  components: {
    Jtron,
    Solutions,
    AirPms,
    About,
  },
  props: {

  },
      
 computed: {
  
},
 watch: {
   
}
}

</script>

<style scoped>


</style>
